import { Body } from 'components/Layout';
import { styled } from 'libs/ui/styled';

export const ContentStyled = styled(Body)(() => ({}));
